import { Organization } from '../../viewModels/Organization';

export interface OrganizationGroup<T> {
    org: T;
    sites: Array<T>;
}

type GroupableOrganization = Pick<Organization, 'id' | 'parentOrgId'>;

// A "site" is an organization with a parentOrgId; every other org is a top-level entry.
// Assumes the full org list, so every site's parent is present.
export const groupOrganizationsByHead = <T extends GroupableOrganization>(
    organizations: Array<T>,
): Array<OrganizationGroup<T>> => {
    const sitesByParentId = new Map<string, Array<T>>();
    for (const org of organizations) {
        if (!org.parentOrgId) continue;
        const siblings = sitesByParentId.get(org.parentOrgId) ?? [];
        siblings.push(org);
        sitesByParentId.set(org.parentOrgId, siblings);
    }

    return organizations
        .filter(org => !org.parentOrgId)
        .map(org => ({
            org,
            sites: sitesByParentId.get(org.id) ?? [],
        }));
};
